import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataInput } from '../../../../interface/interfaces';

interface IInitialState {
    deleteAvatarLoading: boolean;
    deleteAvatarData: string;
    deleteAvatarError: string;
}

const initialState: IInitialState = {
    deleteAvatarLoading: false,
    deleteAvatarData: '',
    deleteAvatarError: '',
};

const deleteAvatarSlice = createSlice({
    name: 'merging',//moze bit problematicno
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchDeleteAvatarPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.deleteAvatarLoading = true;
            state.deleteAvatarData = '';
        },

        fetchDeleteAvatarFulfilled: (state: IInitialState, action: PayloadAction<string>) => {
            state.deleteAvatarLoading = false;
            state.deleteAvatarData = action.payload;
            state.deleteAvatarError = '';
        },
        fetchDeleteAvatarFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.deleteAvatarLoading = false;
            state.deleteAvatarData = '';
            state.deleteAvatarError = action.payload;
        },
    },
});

export default deleteAvatarSlice.reducer;
export const { fetchDeleteAvatarPending, fetchDeleteAvatarFulfilled, fetchDeleteAvatarFailure } = deleteAvatarSlice.actions;
